import { render, staticRenderFns } from "./aid.vue?vue&type=template&id=2c6f904c&lang=pug&"
import script from "./aid.vue?vue&type=script&lang=js&"
export * from "./aid.vue?vue&type=script&lang=js&"
import style0 from "./aid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/.15.7.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports